/**
 * Route Studio top-level routing map - list keys only.
 *
 * THE hand-maintained source of truth for Route Studio tab paths. The
 * page registry (`src/modules/route-studio/routing/registry.tsx`)
 * derives its routes from `ROUTE_STUDIO_PAGES`; an `AssertKeysInMap`
 * guard there fails `ts:check` if a registry key has no matching key
 * here or in the Route Migration map, so the maps cannot drift.
 *
 * F4a (SBX-452, D74): seven machinery tabs collapse into the four
 * verb destinations - Overview, Import, Improve, Go live. The seven
 * old paths live on as redirects declared in
 * `src/modules/route-studio/routing/redirects.tsx`, never here.
 *
 * PRODUCT-378: Import, Improve and Go live moved to Settings → Route
 * Migration (`./settings/route-migration.tsx`), so only Overview is
 * left under `/app/route-studio`. The old `/app/route-studio/import`,
 * `/improve` and `/golive` paths (and their children) redirect there.
 */
import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

export const createRouteStudioRoutesMap = (prefix: string) => ({
  // "See my operation" - the landing page (SPEC 2.1).
  overview: pathJoin(prefix)('overview').chainWithTitle({
    title: <T _str="Overview" />,
    breadCrumbTitle: <T _str="Overview" />,
  }),
})
